<template>
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.82835 4.38356C10.1595 3.92647 10.3556 3.36125 10.3556 2.75C10.3556 1.23366 9.14931 0 7.66667 0C6.18402 0 4.97778 1.23366 4.97778 2.75C4.97778 3.36125 5.17388 3.92647 5.50498 4.38356C4.62899 4.70244 4 5.55853 4 6.5625V9.84375C4 10.6169 4.5207 11.268 5.22222 11.4496V14.3438C5.22222 15.257 5.94871 16 6.84167 16H8.49167C9.38462 16 10.1111 15.257 10.1111 14.3438V11.4496C10.8126 11.268 11.3333 10.6169 11.3333 9.84375V6.5625C11.3333 5.55853 10.7043 4.70244 9.82835 4.38356ZM7.66667 1C8.61169 1 9.37778 1.7835 9.37778 2.75C9.37778 3.7165 8.61169 4.5 7.66667 4.5C6.72164 4.5 5.95556 3.7165 5.95556 2.75C5.95556 1.7835 6.72164 1 7.66667 1ZM9.71389 10.5C10.0683 10.5 10.3556 10.2062 10.3556 9.84375V6.5625C10.3556 5.83763 9.78099 5.25 9.07222 5.25H8.78622C8.06236 5.59044 7.24106 5.57634 6.54711 5.25H6.26111C5.55234 5.25 4.97778 5.83763 4.97778 6.5625V9.84375C4.97778 10.2062 5.26506 10.5 5.61944 10.5H6.2V14.3438C6.2 14.7062 6.48728 15 6.84167 15H8.49167C8.84605 15 9.13333 14.7062 9.13333 14.3438V10.5H9.71389Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "HeightIcon",
};
</script>
